import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './cube-ui'
import api from './api'
import EncryptUtil from "./utils/encrypt";
import checkBrowser from './utils/checkBrowser'
import wxPay from './utils/wxPay'
import szbPay from './utils/szbPay'
//路边
import roadsidewxPay from './utils/roadsidewxPay'
import {formatDate, transDate} from "./utils/formatDate";
import weui from 'weui.js'
// import 'weui'
import Cookies from 'js-cookie'
import 'common/stylus/index.styl'
import "common/fonts/iconfont/iconfont.css"
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import {toPay} from './utils/pay'
//路边
import {roadsidePay} from './utils/pay'

import {loadScript} from './utils/loadScript'
import { getAdInfo } from "./utils/getAbInfo";
import noData from './components/weChat/components/noData'
require('es6-promise').polyfill();
Es6Promise.polyfill();
Vue.use(require('vue-wechat-title'));

Vue.config.productionTip = false;
import wx from "weixin-jsapi";//公众号使用
// import wx from 'weixin-js-sdk'//小程序支付有关
Vue.prototype.wx = wx;
Vue.prototype.$pay = toPay;
//路边支付
Vue.prototype.$roadsidePay = roadsidePay;

Vue.prototype.$weui = weui;
Vue.prototype.$api = api;
Vue.prototype.$encryptUtil = EncryptUtil;
Vue.prototype.$loadScript = loadScript;
Vue.prototype.$getAdInfo = getAdInfo;
Vue.prototype.$wxPay = wxPay;
Vue.prototype.$szbPay = szbPay;
//路边
Vue.prototype.$roadsidewxPay = roadsidewxPay;
Vue.prototype.Cookies = Cookies;
Vue.prototype.formatDate = formatDate;
Vue.prototype.transDate = transDate;

Vue.prototype.checkBrowser = checkBrowser;
Vue.component("no-data",noData);



import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import { VueJsonp } from 'vue-jsonp'

Vue.use(VueJsonp);


const app = new Vue({
  router,
  store,
  render: h => h(App)
});
// 应用入口统一判断：必须在微信/支付宝中打开
if (checkBrowser && checkBrowser.id) {
  // 平台合法，正常挂载
  app.$mount('#app');
} else {
  // 平台不合法：提示用户，绝不挂载 Vue / 不加载任何页面
  weui.alert('请使用微信或支付宝扫码打开本页面', {
    title: '提示'
  });
  // 关键：这里不调用 $mount，页面主体不会渲染，后续路由/请求都不会发生
}